/* sp-pdp-header.js — encabezado compacto de la ficha del kit Shopify maker (PAR-136; CONTRACTS §K.3). Lo carga con defer
   snippets/sp-pdp-header.liquid (part 'price') sólo con el setting sp_header_style "compact-left" de main-product.
   Idempotente (flag global) y con un solo listener en document (captura), así sobrevive a los re-renders del editor.
   El precio, el tachado y sus etiquetas los reescribe theme.js (updatePrice, también con bundle: el precio ahora existe);
   acá, en variantChange (lo despacha theme.Variants en el contenedor de la sección y no burbujea: en captura, acotado a esa
   ficha), la píldora [data-sp-save] ("Ahorrás N%", N = round((tachado - precio) * 100 / tachado), oculta sin precio
   anterior; con data-sp-save-format="amount", 2026-10-19, "Ahorrás $N" = tachado - precio en el formato de la tienda) y las cuotas [data-sp-installments] (monto = round(precio / cuotas) en centavos con theme.Currency.formatMoney
   y el formato de la tienda, igual que money_without_trailing_zeros en el Liquid). Los textos salen de data-sp-tpl ([n],
   [count], [amount]; el monto sin etiquetas, por un money_format con HTML). Sin el formateador del tema, el texto de las cuotas queda como lo dibujó el servidor. Sin listeners
   de scroll ni de gesto. */
(function () {
  'use strict';
  if (window.__spPdpHeaderInit) return;
  window.__spPdpHeaderInit = true;

  function money(cents) {
    var t = window.theme;
    if (t && t.Currency && typeof t.Currency.formatMoney === 'function') return t.Currency.formatMoney(cents, t.settings && t.settings.moneyFormat);
    return null;
  }

  function plain(m) {
    return m === null ? null : String(m).replace(/<[^>]*>/g, '').replace(/[.,]00(?=\D*$)/, '');
  }

  function apply(row, v) {
    var price = parseInt(v.price, 10);
    if (isNaN(price)) return;
    var cmp = parseInt(v.compare_at_price, 10) || 0;
    var save = row.querySelector('[data-sp-save]');
    if (save) {
      var on = cmp > price;
      save.classList.toggle('hide', !on);
      // "Ahorrás $600" con data-sp-save-format="amount" (offer.priceDisplay.saveFormat): el monto con el formato de la tienda,
      // sin etiquetas ni ",00", igual que money_without_trailing_zeros; sin el formateador del tema queda el texto del servidor
      var amountMode = save.getAttribute('data-sp-save-format') === 'amount';
      var shown = amountMode ? plain(money(cmp - price)) : Math.round(((cmp - price) * 100) / cmp) + '%';
      if (shown !== null) save.textContent = on ? String(save.getAttribute('data-sp-tpl') || '').replace('[n]', shown) : '';
    }
    var cuotas = row.parentNode && row.parentNode.querySelector('[data-sp-installments]');
    if (cuotas) {
      var n = parseInt(cuotas.getAttribute('data-sp-installments'), 10) || 0;
      // precio sin centavos: la cuota en pesos enteros, como el Liquid ("$241", no "$240,83"); sin ",00" al final
      var cuota = price % 100 === 0 ? Math.round(price / n / 100) * 100 : Math.round(price / n);
      var amount = n > 1 ? money(cuota) : null;
      if (amount !== null) amount = String(amount).replace(/<[^>]*>/g, '').replace(/[.,]00(?=\D*$)/, '');
      if (amount !== null) cuotas.textContent = String(cuotas.getAttribute('data-sp-tpl') || '').replace('[count]', String(n)).replace('[amount]', amount);
    }
  }

  document.addEventListener('variantChange', function (e) {
    var v = e.detail && e.detail.variant;
    var scope = e.target;
    if (!v || !scope || typeof scope.querySelectorAll !== 'function') return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-sp-ph-price]'), function (row) { apply(row, v); });
  }, true);
})();
